(function () {
    const MAX_PER_TYPE = 2;
    const MAX_TOTAL = 6;
    const BUNDLE_PRODUCT_ID = '8456437006497';

    // ΓöÇΓöÇΓöÇ CART CACHE (prevents redundant fetches) ΓöÇΓöÇΓöÇΓöÇΓöÇΓöÇΓöÇΓöÇΓöÇΓöÇΓöÇΓöÇΓöÇΓöÇΓöÇΓöÇΓöÇΓöÇΓöÇΓöÇΓöÇΓöÇ
    let cachedCart = null;

    // Helper: current qty in cart for a given product/variant id
    function getQtyInCart(cart, id) {
      if (!cart || !id) return 0;
      const key = String(id);
      return cart.items
        .filter(i => String(i.product_id) === key || String(i.variant_id) === key)
        .reduce((sum, i) => sum + i.quantity, 0);
    }

    // ΓöÇΓöÇΓöÇ CORE: Enforce rules via Shopify Cart API ΓöÇΓöÇΓöÇΓöÇΓöÇΓöÇΓöÇΓöÇΓöÇΓöÇΓöÇΓöÇΓöÇΓöÇΓöÇΓöÇΓöÇΓöÇΓöÇΓöÇΓöÇ
    function enforceCartRules(callback) {
      originalFetch('/cart.js')
        .then(r => r.json())
        .then(cart => {
          cachedCart = cart;
          const updates = {};
          let needsUpdate = false;

          cart.items.forEach(item => {
            if (String(item.product_id) === BUNDLE_PRODUCT_ID) return;
            if (item.quantity > MAX_PER_TYPE) {
              updates[item.key] = MAX_PER_TYPE;
              needsUpdate = true;
            }
          });

          if (needsUpdate) {
            originalFetch('/cart/update.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ updates })
            })
              .then(r => r.json())
              .then(updatedCart => {
                cachedCart = updatedCart;
                showToast(`Only ${MAX_PER_TYPE} per hat style allowed.`);
                if (callback) callback();
                applyUI(updatedCart);
              });
          } else {
            if (callback) callback();
            applyUI(cart);
          }
        });
    }

    // ΓöÇΓöÇΓöÇ INTERCEPT Shopify's fetch ΓöÇΓöÇΓöÇΓöÇΓöÇΓöÇΓöÇΓöÇΓöÇΓöÇΓöÇΓöÇΓöÇΓöÇΓöÇΓöÇΓöÇΓöÇΓöÇΓöÇΓöÇΓöÇΓöÇΓöÇΓöÇΓöÇΓöÇΓöÇΓöÇΓöÇΓöÇΓöÇΓöÇΓöÇΓöÇΓöÇ
    const originalFetch = window.fetch;
    window.fetch = function (url, options) {

      // ΓöÇΓöÇ /cart/add (pre-check then original handler) ΓöÇΓöÇΓöÇΓöÇΓöÇΓöÇΓöÇΓöÇΓöÇΓöÇΓöÇΓöÇΓöÇΓöÇΓöÇ
      if (typeof url === 'string' && url.includes('/cart/add')) {
        // Pre-check: block add if product at MAX_PER_TYPE or cart full
        const cart = cachedCart;
        if (cart) {
          const totalQty = cart.items
            .filter(i => String(i.product_id) !== BUNDLE_PRODUCT_ID)
            .reduce((sum, i) => sum + i.quantity, 0);

          // Parse the add payload
          let addBody = {};
          try {
            if (options?.body) {
              addBody = typeof options.body === 'string'
                ? (options.body.startsWith('{') ? JSON.parse(options.body) : Object.fromEntries(new
  URLSearchParams(options.body)))
                : {};
            }
          } catch(e) {}
          const addId = String(addBody.id || addBody.product_id || '');
          const isBundle = cart.items.some(i => String(i.product_id) === BUNDLE_PRODUCT_ID &&
  (String(i.product_id) === addId || String(i.variant_id) === addId));

          // Only check total limit for non-bundle items
          if (!isBundle && totalQty >= MAX_TOTAL) {
            showToast(`Max ${MAX_TOTAL} hats total.`);
            return Promise.resolve(new Response(JSON.stringify(cart), {
              status: 200, headers: { 'Content-Type': 'application/json' }
            }));
          }
          // Check if this exact product is already at MAX_PER_TYPE in cart
          const currentQty = getQtyInCart(cart, addId);
          if (addId && currentQty >= MAX_PER_TYPE) {
            showToast(isBundle ? 'Only 1 bundle allowed.' : `Only ${MAX_PER_TYPE} per hat style allowed.`);
            return Promise.resolve(new Response(JSON.stringify(cart), {
              status: 200, headers: { 'Content-Type': 'application/json' }
            }));
          }
          // Bundle is still limited to 1
          if (isBundle && currentQty >= 1) {
            showToast('Only 1 bundle allowed.');
            return Promise.resolve(new Response(JSON.stringify(cart), {
              status: 200, headers: { 'Content-Type': 'application/json' }
            }));
          }
        }
        // ΓöÇΓöÇ Original handler (unchanged) ΓöÇΓöÇΓöÇΓöÇΓöÇΓöÇΓöÇΓöÇΓöÇΓöÇΓöÇΓöÇΓöÇΓöÇΓöÇΓöÇΓöÇΓöÇΓöÇΓöÇΓöÇΓöÇΓöÇΓöÇΓöÇΓöÇΓöÇΓöÇ
        return originalFetch(url, options).then(response => {
          originalFetch('/cart.js')
            .then(r => r.json())
            .then(cart => {
              cachedCart = cart;

              const updates = {};
              let needsUpdate = false;
              cart.items.forEach(item => {
                if (String(item.product_id) === BUNDLE_PRODUCT_ID) return;
                if (item.quantity > MAX_PER_TYPE) {
                  updates[item.key] = MAX_PER_TYPE;
                  needsUpdate = true;
                }
              });

              if (needsUpdate) {
                originalFetch('/cart/update.js', {
                  method: 'POST',
                  headers: { 'Content-Type': 'application/json' },
                  body: JSON.stringify({ updates })
                })
                  .then(r => r.json())
                  .then(updatedCart => {
                    cachedCart = updatedCart;
                    showToast(`Only ${MAX_PER_TYPE} per hat style allowed.`);
                    applyUI(updatedCart);
                    document.dispatchEvent(new CustomEvent('cart:updated'));
                  });
              } else {
                applyUI(cart);
                document.dispatchEvent(new CustomEvent('cart:updated'));
              }
            });
          return response;
        });
      }

      // ΓöÇΓöÇ /cart/change (also handles REMOVE which sends quantity: 0) ΓöÇΓöÇ
      if (typeof url === 'string' && url.includes('/cart/change')) {
        let body = {};
        try { body = JSON.parse(options?.body || '{}'); } catch (e) {}

        // BUG FIX: quantity === 0 means REMOVE ΓÇö never block it,
        // pass through immediately with no extra fetch
        if (body.quantity === 0) {
          return originalFetch(url, options).then(response => {
            response.clone().json().then(cart => {
              cachedCart = cart;
              applyUI(cart);
              document.dispatchEvent(new CustomEvent('cart:updated'));
            }).catch(() => {});
            return response;
          });
        }

        // Block quantity > MAX_PER_TYPE
        if (body.quantity > MAX_PER_TYPE) {
          showToast(`Only ${MAX_PER_TYPE} per hat style allowed.`);
          if (cachedCart) {
            return Promise.resolve(new Response(JSON.stringify(cachedCart), {
              status: 200,
              headers: { 'Content-Type': 'application/json' }
            }));
          }
          return originalFetch('/cart.js').then(r => r.json()).then(cart => {
            cachedCart = cart;
            return new Response(JSON.stringify(cart), {
              status: 200,
              headers: { 'Content-Type': 'application/json' }
            });
          });
        }

        // Check total won't exceed MAX_TOTAL
        const checkAndProceed = (cart) => {
          const total = cart.items
            .filter(i => String(i.product_id) !== BUNDLE_PRODUCT_ID)
            .reduce((sum, i) => sum + i.quantity, 0);
          const thisItem = cart.items.find(i => i.key === body.id || i.key === body.key);
          const currentQty = thisItem?.quantity || 0;
          const diff = (body.quantity || 0) - currentQty;

          if (total + diff > MAX_TOTAL) {
            showToast(`Max ${MAX_TOTAL} hats total.`);
            return Promise.resolve(new Response(JSON.stringify(cart), {
              status: 200,
              headers: { 'Content-Type': 'application/json' }
            }));
          }
          return originalFetch(url, options);
        };

        if (cachedCart) {
          return checkAndProceed(cachedCart);
        }

        return originalFetch('/cart.js')
          .then(r => r.json())
          .then(cart => {
            cachedCart = cart;
            return checkAndProceed(cart);
          });
      }

      return originalFetch(url, options);
    };

    // ΓöÇΓöÇΓöÇ INTERCEPT XMLHttpRequest ΓöÇΓöÇΓöÇΓöÇΓöÇΓöÇΓöÇΓöÇΓöÇΓöÇΓöÇΓöÇΓöÇΓöÇΓöÇΓöÇΓöÇΓöÇΓöÇΓöÇΓöÇΓöÇΓöÇΓöÇΓöÇΓöÇΓöÇΓöÇΓöÇΓöÇΓöÇΓöÇΓöÇΓöÇΓöÇΓöÇΓöÇ
    const originalOpen = XMLHttpRequest.prototype.open;
    const originalSend = XMLHttpRequest.prototype.send;

    XMLHttpRequest.prototype.open = function (method, url, ...args) {
      this._url = url;
      return originalOpen.apply(this, [method, url, ...args]);
    };

    XMLHttpRequest.prototype.send = function (body) {
      if (this._url && this._url.includes('/cart/change')) {
        let parsed = {};
        try {
          parsed = typeof body === 'string'
            ? (body.startsWith('{') ? JSON.parse(body) : Object.fromEntries(new URLSearchParams(body)))
            : {};
        } catch (e) {}

        // Never block removes (quantity === 0)
        if (parsed.quantity === 0) {
          return originalSend.apply(this, arguments);
        }

        if (parsed.quantity > MAX_PER_TYPE) {
          showToast(`Only ${MAX_PER_TYPE} per hat style allowed.`);
          enforceCartRules(() => {
            document.dispatchEvent(new CustomEvent('cart:updated'));
          });
          return;
        }
      }
      return originalSend.apply(this, arguments);
    };

    // ΓöÇΓöÇΓöÇ UI: Apply all UI updates using cart data ΓöÇΓöÇΓöÇΓöÇΓöÇΓöÇΓöÇΓöÇΓöÇΓöÇΓöÇΓöÇΓöÇΓöÇΓöÇΓöÇΓöÇΓöÇΓöÇΓöÇΓöÇ
    function updateAllUI(cartData) {
      if (cartData) {
        cachedCart = cartData;
        applyUI(cartData);
      } else if (cachedCart) {
        applyUI(cachedCart);
      } else {
        originalFetch('/cart.js')
          .then(r => r.json())
          .then(cart => {
            cachedCart = cart;
            applyUI(cart);
          });
      }
    }

    function applyUI(cart) {
      const totalQty = cart.items
        .filter(i => String(i.product_id) !== BUNDLE_PRODUCT_ID)
        .reduce((sum, i) => sum + i.quantity, 0);
      disablePlusButtons(cart);
      disableAddToCartBtn(cart, totalQty);
      updateCartCount(cart.item_count);
    }

    function disablePlusButtons(cart) {
      setTimeout(() => {
        const plusSelectors = [
          '.quantity__button[name="plus"]',
          '[data-quantity-plus]',
          '.cart-item__quantity button:last-child',
          'button[aria-label*="Increase"]',
          'button[aria-label*="increase"]',
          '.qty__adjust--plus',
          '[data-action="increment"]'
        ];

        // Per-item: disable plus only when that item is at MAX_PER_TYPE
        // Fallback: legacy selectors without item context ΓÇö disable uniformly
        plusSelectors.forEach(sel => {
          document.querySelectorAll(sel).forEach(btn => {
            btn.title = `Max ${MAX_PER_TYPE} per hat style`;
            // Try to find the associated line-item key/variant to scope the disable
            const lineItem = btn.closest('[data-cart-item], [data-key], [data-variant-id]');
            let atLimit = false;
            if (lineItem && cart) {
              const key = lineItem.dataset.key || lineItem.dataset.cartItem;
              const variantId = lineItem.dataset.variantId;
              const match = cart.items.find(i =>
                (key && i.key === key) ||
                (variantId && String(i.variant_id) === String(variantId))
              );
              if (match && match.quantity >= MAX_PER_TYPE) atLimit = true;
            }
            if (atLimit || !lineItem) {
              btn.disabled = !!atLimit;
              btn.style.opacity = atLimit ? '0.3' : '';
              btn.style.cursor = atLimit ? 'not-allowed' : '';
              btn.style.pointerEvents = atLimit ? 'none' : '';
            } else {
              btn.disabled = false;
              btn.style.opacity = '';
              btn.style.cursor = '';
              btn.style.pointerEvents = '';
            }
          });
        });

        const qtyInputSelectors = [
          '.quantity__input',
          'input[name="quantity"]',
          '.cart-item__quantity input',
          '[data-quantity-input]'
        ];

        qtyInputSelectors.forEach(sel => {
          document.querySelectorAll(sel).forEach(input => {
            input.readOnly = true;
            input.style.pointerEvents = 'none';
            input.max = String(MAX_PER_TYPE);
          });
        });
      }, 150);
    }

    function disableAddToCartBtn(cart, totalQty) {
      const addBtnSelectors = [
        'button[name="add"]',
        '#AddToCart',
        '.product-form__cart-submit',
        '[data-type="add-to-cart-btn"]',
        'button[data-add-to-cart]'
      ];

      if (!document.getElementById('hat-btn-tooltip-style')) {
        const style = document.createElement('style');
        style.id = 'hat-btn-tooltip-style';
        style.textContent = `
          .hat-btn-wrapper {
            position: relative;
            display: inline-block;
            width: 100%;
          }
          .hat-btn-wrapper .hat-tooltip {
            visibility: hidden;
            opacity: 0;
            background: rgba(0, 0, 0, 0.85);
            color: #fff;
            font-size: 12px;
            font-weight: 500;
            letter-spacing: 0.5px;
            text-align: center;
            padding: 7px 14px;
            border-radius: 6px;
            border: 1px solid rgba(255,255,255,0.15);
            position: absolute;
            bottom: calc(100% + 10px);
            left: 50%;
            transform: translateX(-50%);
            white-space: nowrap;
            z-index: 9999;
            transition: opacity 0.2s ease;
            pointer-events: none;
          }
          .hat-btn-wrapper .hat-tooltip::after {
            content: '';
            position: absolute;
            top: 100%;
            left: 50%;
            transform: translateX(-50%);
            border: 5px solid transparent;
            border-top-color: rgba(0,0,0,0.85);
          }
          .hat-btn-wrapper:hover .hat-tooltip {
            visibility: visible;
            opacity: 1;
          }
        `;
        document.head.appendChild(style);
      }

      const productId = getProductIdFromPage();
      const currentQty = getQtyInCart(cart, productId);

      addBtnSelectors.forEach(sel => {
        document.querySelectorAll(sel).forEach(btn => {
          const isBundle = String(productId) === BUNDLE_PRODUCT_ID;
          const perTypeMax = isBundle ? 1 : MAX_PER_TYPE;
          const atLimit = productId && currentQty >= perTypeMax;
          const cartFull = !isBundle && totalQty >= MAX_TOTAL;

          if (atLimit || cartFull) {
            if (!btn.parentElement.classList.contains('hat-btn-wrapper')) {
              const wrapper = document.createElement('div');
              wrapper.className = 'hat-btn-wrapper';

              const tooltip = document.createElement('span');
              tooltip.className = 'hat-tooltip';
              if (atLimit) {
                tooltip.textContent = isBundle
                  ? '≡ƒöÆ Bundle already in your cart'
                  : `≡ƒöÆ Max ${MAX_PER_TYPE} of this hat already in your cart`;
              } else {
                tooltip.textContent = `≡ƒöÆ Cart full (${MAX_TOTAL} hats max)`;
              }

              btn.parentNode.insertBefore(wrapper, btn);
              wrapper.appendChild(btn);
              wrapper.appendChild(tooltip);
            }

            btn.disabled = true;
            btn.style.opacity = '0.45';
            btn.style.cursor = 'not-allowed';
            btn.style.pointerEvents = 'none';
            btn.parentElement.style.pointerEvents = 'auto';
            btn.parentElement.style.cursor = 'not-allowed';

          } else {
            if (btn.parentElement.classList.contains('hat-btn-wrapper')) {
              const wrapper = btn.parentElement;
              wrapper.parentNode.insertBefore(btn, wrapper);
              wrapper.remove();
            }

            btn.disabled = false;
            btn.style.opacity = '';
            btn.style.cursor = '';
            btn.style.pointerEvents = '';
          }
        });
      });
    }

    function getProductIdFromPage() {
      if (window.ShopifyAnalytics?.meta?.product?.id) {
        return window.ShopifyAnalytics.meta.product.id;
      }
      const meta = document.querySelector('meta[property="og:url"]');
      if (meta) {
        const match = meta.content.match(/\/products\/([^?\/]+)/);
        if (match) return match[1];
      }
      const input = document.querySelector('input[name="product-id"], [data-product-id]');
      return input?.value || input?.dataset?.productId || null;
    }

    // ΓöÇΓöÇΓöÇ CART COUNT BADGE ΓöÇΓöÇΓöÇΓöÇΓöÇΓöÇΓöÇΓöÇΓöÇΓöÇΓöÇΓöÇΓöÇΓöÇΓöÇΓöÇΓöÇΓöÇΓöÇΓöÇΓöÇΓöÇΓöÇΓöÇΓöÇΓöÇΓöÇΓöÇΓöÇΓöÇΓöÇΓöÇΓöÇΓöÇΓöÇΓöÇΓöÇΓöÇΓöÇΓöÇΓöÇΓöÇΓöÇΓöÇΓöÇ
    function updateCartCount(count) {
      document.querySelectorAll('.cart-count-badge, .cart-count, [data-cart-count]').forEach(el => {
        el.textContent = count;
        el.style.display = count > 0 ? 'flex' : 'none';
      });
    }

    // ΓöÇΓöÇΓöÇ TOAST NOTIFICATION ΓöÇΓöÇΓöÇΓöÇΓöÇΓöÇΓöÇΓöÇΓöÇΓöÇΓöÇΓöÇΓöÇΓöÇΓöÇΓöÇΓöÇΓöÇΓöÇΓöÇΓöÇΓöÇΓöÇΓöÇΓöÇΓöÇΓöÇΓöÇΓöÇΓöÇΓöÇΓöÇΓöÇΓöÇΓöÇΓöÇΓöÇΓöÇΓöÇΓöÇΓöÇΓöÇΓöÇ
    function showToast(msg) {
      let toast = document.getElementById('hat-cart-toast');
      if (!toast) {
        toast = document.createElement('div');
        toast.id = 'hat-cart-toast';
        toast.style.cssText = `
          position: fixed;
          bottom: 30px;
          left: 50%;
          transform: translateX(-50%);
          background: #111;
          color: #fff;
          padding: 14px 28px;
          border-radius: 10px;
          font-size: 14px;
          font-weight: 600;
          z-index: 99999;
          box-shadow: 0 6px 30px rgba(0,0,0,0.5);
          border: 1px solid rgba(255,255,255,0.2);
          transition: opacity 0.4s ease;
          white-space: nowrap;
        `;
        document.body.appendChild(toast);
      }
      toast.textContent = '≡ƒºó ' + msg;
      toast.style.opacity = '1';
      clearTimeout(toast._t);
      toast._t = setTimeout(() => { toast.style.opacity = '0'; }, 3000);
    }

    // ΓöÇΓöÇΓöÇ OBSERVE DOM CHANGES (debounced to prevent cascade) ΓöÇΓöÇΓöÇΓöÇΓöÇΓöÇΓöÇΓöÇΓöÇΓöÇΓöÇ
    let observerTimeout = null;
    const observer = new MutationObserver(() => {
      clearTimeout(observerTimeout);
      observerTimeout = setTimeout(() => {
        if (cachedCart) {
          applyUI(cachedCart);
        } else {
          updateAllUI();
        }
      }, 300);
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });

    // ΓöÇΓöÇΓöÇ INIT ΓöÇΓöÇΓöÇΓöÇΓöÇΓöÇΓöÇΓöÇΓöÇΓöÇΓöÇΓöÇΓöÇΓöÇΓöÇΓöÇΓöÇΓöÇΓöÇΓöÇΓöÇΓöÇΓöÇΓöÇΓöÇΓöÇΓöÇΓöÇΓöÇΓöÇΓöÇΓöÇΓöÇΓöÇΓöÇΓöÇΓöÇΓöÇΓöÇΓöÇΓöÇΓöÇΓöÇΓöÇΓöÇΓöÇΓöÇΓöÇΓöÇΓöÇΓöÇΓöÇΓöÇΓöÇΓöÇΓöÇΓöÇ
    document.addEventListener('DOMContentLoaded', () => {
      enforceCartRules();
    });

    document.addEventListener('cart:updated', () => updateAllUI());
  })();
  